module.exports = __webpack_public_path__ + "media/images/8_help-38bb9e24232b1cfcc6531d58c328fab9.jpg";